import React, { useState } from "react";
import Navbar from "../../../Components/Desktop/Navbar/Navbar";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "./HomePage.scss";
import Footer from "../../../Components/Desktop/Footer/Footer";
import BlueBox from "./BlueBox/BlueBox";
import ClaimBox from "./ClaimBox/ClaimBox";
import FAQ from "../../../Components/Desktop/FAQ/FAQ";
import MultipleSearchDropdown from "../../../Components/Common/FieldTypes/MultipleSearchDropdown/MultiSearchDropdown";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";
import DatePicker from "../../../Components/Common/FieldTypes/DatePicker/DatePicker";

function HomePage() {
  const navigate = useNavigate();
  const [fieldData, setFieldData] = useState<{
    startDate: string | null;
    endDate: string | null;
  }>({ endDate: null, startDate: null });
  const [formFields, setFormFields] = useState<{
    firstName: { value: string; warning: boolean };
    country: { value: string; warning: boolean };
    gender: { value: string; warning: boolean };
    pinCode: { value: string; warning: boolean };
    mobile: { value: string; warning: boolean };
  }>({
    firstName: { value: "", warning: false },
    country: { value: "", warning: false },
    gender: { value: "", warning: false },
    pinCode: { value: "", warning: false },
    mobile: { value: "", warning: false },
  });
  const travel_Data = [
    { label: "India", title: "India" },
    { label: "Australia", title: "Australia" },
  ];

  const fieldsUpdateState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  const faqs = [
    {
      expanded: "panel1",
      title: "Is it necessary to buy overseas travel insurance?",
      description: "Insurance",
    },
    {
      expanded: "panel2",
      title: "Does international travel insurance cover missed flights?",
      description:
        "Not all countries mandate overseas travel insurance for visa purposes. But it is an important thing all travellers must have before they leave for their trip.",
    },
    {
      expanded: "panel3",
      title: "Can I buy overseas travel insurance after booking my tickets?",
      description: "Insurance",
    },
    {
      expanded: "panel4",
      title: "Can I buy overseas travel insurance after booking my tickets?",
      description: "Insurance",
    },
    {
      expanded: "panel5",
      title:
        "What are the eligibility criteria to get an international travel insurance?",
      description: "Insurance",
    },
    {
      expanded: "panel6",
      title:
        "What are the eligibility criteria to get an international travel insurance?",
      description: "Insurance",
    },
    {
      expanded: "panel7",
      title: "Is it necessary to buy overseas travel insurance?",
      description: "Insurance",
    },
    {
      expanded: "panel8",
      title: "What",
      description: "Insurance",
    },
  ];
  return (
    <>
      <Navbar />
      <Box className="homeWrapper">
        <header>
          <Grid container>
            <Grid xs={12}>
              <h2>
                Protect Your Journey <span>Travel Insurance</span>
              </h2>
            </Grid>
            <Grid xs={12}>
              <Box className="offerBox">
                <img src="./images/smiley.svg" width="46px" />
                <div>
                  <h2>₹50</h2>
                  <p>per day start from only*</p>
                </div>
              </Box>
            </Grid>
            <Grid xs={12}>
              <Box className="formBox">
                <h4 className="py-3 px-3 mb-4">
                  Worries Vanished - Get Insured Now
                </h4>
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <MultipleSearchDropdown
                      class_name="inputField"
                      title="Where do you want to travel?"
                      value={formFields.country.value}
                      attrName={["country", "value", formFields, setFormFields]}
                      value_update={fieldsUpdateState}
                      multiple_data={travel_Data}
                      warn_status={formFields.country.warning}
                      error_message={"Select country"}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <DatePicker
                      class_name="inputField"
                      title={"Start Date"}
                      value={fieldData.startDate}
                      attrName={"startDate"}
                      value_update={(attr: any, value: any) => {
                        setFieldData((prev) => ({ ...prev, startDate: value }));
                      }}
                      warn_status={false}
                      error_message={"Enter Reg. Date"}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <DatePicker
                      class_name="inputField"
                      title={"End Date"}
                      value={fieldData.endDate}
                      attrName={"endDate"}
                      value_update={(attr: any, value: any) => {
                        setFieldData((prev) => ({ ...prev, endDate: value }));
                      }}
                      warn_status={false}
                      error_message={"Enter Reg. Date"}
                    />
                  </Grid>
                  <Grid xs={12} className="ctaBtn text-center">
                    <CustomButton
                      class_name="blueLgBtn"
                      onClickFunction={() => {
                        navigate(PATH.QUOTE_PAGE);
                      }}
                      text_name="Continue"
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </header>

        <div className="relative w-full flex flex-col py-20 px-3 mx-auto box-border items-start justify-start gap-[80px] max-w-[1460px] text-left">
          <div className="self-stretch flex flex-row flex-wrap items-center justify-start gap-[24px] lg:flex-row lg:gap-[24px] lg:items-center lg:justify-start md:flex-row md:gap-[24px] md:items-center md:justify-start sm:flex-col sm:gap-[24px] sm:items-center sm:justify-start">
            <div className="flex-1 flex flex-col items-start justify-center gap-[8px] min-w-[360px] sm:self-stretch">
              <h2>What is Travel Insurance?</h2>
              <p>
                It's one of those things we all look forward to, no matter where
                we plan to take off. From sandy beaches and snow-covered
                mountains to the hilly greens and bustling cities; the world is
                our platter and the very act of traveling- our chance to
                experience at least one portion of it. Travel insurance covers
                cost, losses, and other predefined expenses associated with
                travelling. It insures the policy holders from different types
                of losses they might face during their travel. It covers a range
                of services like baggage/passport loss, flight delays, flight
                cancellations, medical expenses, etc. Your travel insurance is a
                document that acts as a safety net every time you travel.
              </p>
            </div>
            <img
              className="relative w-40"
              alt=""
              src="./images/girl-with-bag.svg"
            />
          </div>
          <div
            className="self-stretch rounded-xl flex flex-row flex-wrap pt-8 px-5 pb-0 items-end justify-start gap-[24px] border-[1px] border-dashed lg:flex-row lg:items-end lg:justify-start md:flex-row md:items-end md:justify-start sm:flex-col sm:items-end sm:justify-start"
            style={{ borderColor: "#6458D8" }}
          >
            <img
              className="w-[264px] h-[302px]"
              alt=""
              src="./images/confused.svg"
            />
            <div className="flex-1 flex flex-col items-start justify-center gap-[14px] min-w-[360px] sm:self-stretch">
              <div className="self-stretch flex flex-col items-start justify-center gap-[8px]">
                <h2>Do I really need a Travel Insurance?</h2>
                <p>If that's a question you've been battling with read on.</p>
              </div>
              <div className="self-stretch flex flex-row flex-wrap pt-[30px] px-0 pb-0 items-center justify-start gap-[24px] lg:flex-row lg:gap-[24px] lg:items-center lg:justify-start md:flex-row md:gap-[24px] md:items-center md:justify-start sm:flex-col sm:gap-[24px] sm:items-center sm:justify-start">
                <BlueBox
                  imgIcon="./images/plane-icon.svg"
                  coverageDescription="Covers third party damages involving your vehicle."
                  divWidth="unset"
                  divBackgroundColor="#6458d8"
                />
                <BlueBox
                  imgIcon="./images/medical-icon.svg"
                  coverageDescription="Medical expenses cost 3 to 5 times more outside your country."
                  divWidth="unset"
                  divBackgroundColor="#786cf0"
                />
                <BlueBox
                  imgIcon="./images/scam-icon.svg"
                  coverageDescription="Travel scams are extremely common in tourist-heavy countries."
                  divWidth="unset"
                  divBackgroundColor="#a096fb"
                />
              </div>
            </div>
          </div>
          <div className="self-stretch rounded-3xl bg-[#EFEEFB] flex flex-col p-6 items-start justify-center gap-[32px] text-center">
            <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
              <h2>How to file a claim?</h2>
              <p>
                After you buy our international travel insurance plan, you live
                tension free as we have a 3-step, completely digital claims
                process!
              </p>
            </div>
            <div className="self-stretch flex flex-row flex-wrap gap-[24px] md:flex-row sm:flex-col">
              <ClaimBox
                notificationText="1."
                notificationDescription="Missed Call"
                callBackMessage="Give us a call at XXXX-XXX-XXXX & we'll call back in 10 mins."
              />
              <ClaimBox
                notificationText="2."
                notificationDescription="Upload Documents"
                callBackMessage="Upload the required documents & your bank account details, on the link sent."
              />
              <ClaimBox
                notificationText="3."
                notificationDescription="Relax"
                callBackMessage="It's time to rest & We'll take care of the rest!"
              />
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-center gap-[32px]">
            <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
              <h2>FAQ's related to buying International Travel Insurance</h2>
              <p className="text-center">
                After you buy our international travel insurance plan, you live
                tension free as we have a 3-step, completely digital claims
                process!
              </p>
              <FAQ data={faqs} />
            </div>
          </div>
        </div>
      </Box>
      <Footer />
    </>
  );
}

export default HomePage;
